import type { GeoLocation } from "./location";

import { api } from "./api";

export type AccountMetadataType = {
  agreesToProductUpdates: boolean;
  geoLocation: GeoLocation;
};

export const saveCCPAOptOut = async ({ optOutCCPA }: { optOutCCPA?: boolean }) => {
  await api.post(`/v1/user/edit`, {
    ccpa_opt_out: optOutCCPA,
  });
};
